var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callout"},[_c('p',{staticClass:"callout__text"},[_vm._v("Você precisa levar o pedido médico original no dia do atendimento.")]),_c('button',{staticClass:"callout__link",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('explain-click')}}},[_vm._v(" Por que preciso levar se já enviei aqui? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }